import { Component, Prop } from "vue-property-decorator";
import { facetModel } from "@/models/facetModel";
import baseUserContextComponent from "../baseUserContextComponent";
import { optionModel, optionValueModel, optionAndSingleValueModel } from "@/models/optionModel";
import { CategoryFavouriteViewModel } from "@/models/categoryFavouriteViewModel";
@Component({})
export default class filterFavouriteCategoryButtonSelector extends baseUserContextComponent {
    @Prop({ default: () => new optionModel() })
    category: CategoryFavouriteViewModel;
    @Prop({ default: () => null })
    categoryId: string;

    onClick(c: CategoryFavouriteViewModel) {
        this.$emit("select", c);
    }

    onNewCategoryClick() {
        this.$emit("on-new-category");
    }

    editCategoryClick(c: CategoryFavouriteViewModel) {
        this.$emit("on-edit-category", c);
    }

    deleteCategoryClick(c: CategoryFavouriteViewModel) {
        this.$emit("on-delete-category", c);
    }
}
